import './App.css';
import FlatDetail from "./components/FlatDetail";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Contact from "./components/Contact";
import About from "./components/About";
import ScrollToTop from "./components/ScrollToTop"; // <-- import it
import { BrowserRouter as Router, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Route path="/" exact component={Home}></Route>
        <Route path="/contact" component={Contact}></Route>
        <Route path="/about" component={About}></Route>
        <Route path="/flat/:slug" component={FlatDetail}></Route>
        <Footer />
        <ScrollToTop /> {/* <-- add this */}
      </div> 
      {/* End  */}
    </Router>
  );
}

export default App;
